import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShirt = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m14.25 8.75 2.25 1.5L18.25 7 12.5 3.75c-.25.75-.75 1.5-2.5 1.5s-2.25-.75-2.5-1.5L1.75 7l1.75 3.25 2.25-1.5v8.5h8.5v-8.5Z"
	})]
});
const ForwardRef = forwardRef(SvgShirt);
export { ForwardRef as ReactComponent };
